export const MASTER_TESTING_SESSION_STORAGE = 'mentology.masterTestingOverride';
export const MASTER_ADMIN_GATE_STORAGE = 'mentology.masterAdminGate';
export const MASTER_ADMIN_TOKEN_STORAGE = 'mentology.masterAdminToken';

function normalizeMasterKey(raw: string): string {
  return String(raw ?? '').replace(/\s/g, '').toUpperCase();
}

export function getMasterTestingKey(): string {
  return (import.meta.env.VITE_MASTER_TESTING_KEY as string | undefined)?.trim() ?? '';
}

export function isMasterTestingKey(input: string): boolean {
  const masterKey = getMasterTestingKey();
  if (!masterKey) return false;
  return normalizeMasterKey(input) === normalizeMasterKey(masterKey);
}

export function activateMasterTestingSession(): void {
  sessionStorage.setItem(MASTER_TESTING_SESSION_STORAGE, '1');
  // Portal login already proved the master key — do not ask again on /master-admin.
  sessionStorage.setItem(MASTER_ADMIN_GATE_STORAGE, '1');
}

export function clearMasterTestingSession(): void {
  sessionStorage.removeItem(MASTER_TESTING_SESSION_STORAGE);
  sessionStorage.removeItem(MASTER_ADMIN_GATE_STORAGE);
}

export function isMasterAdminGateOpen(): boolean {
  return sessionStorage.getItem(MASTER_ADMIN_GATE_STORAGE) === '1';
}

export function openMasterAdminGate(): void {
  sessionStorage.setItem(MASTER_ADMIN_GATE_STORAGE, '1');
}

export function isMasterTestingSessionActive(): boolean {
  return sessionStorage.getItem(MASTER_TESTING_SESSION_STORAGE) === '1';
}

export function rememberMasterAdminToken(token?: string | null): void {
  const value = String(token || '').trim();
  if (!value) return;
  sessionStorage.setItem(MASTER_ADMIN_TOKEN_STORAGE, value);
}

export function readMasterAdminToken(): string {
  try {
    return sessionStorage.getItem(MASTER_ADMIN_TOKEN_STORAGE)?.trim() || '';
  } catch {
    return '';
  }
}

export function clearMasterAdminToken(): void {
  sessionStorage.removeItem(MASTER_ADMIN_TOKEN_STORAGE);
}

export function isMasterSandboxUnlocked(
  user?: { masterTestingOverride?: boolean } | null,
): boolean {
  return isMasterTestingSessionActive() || user?.masterTestingOverride === true;
}
